// AUTO GENERATED BY: build/XT5-webpack/entry-loader.js
__webpack_public_path__ = window.__webpack_public_path__;
require('cui/polyfill/load')(function () { require('coremail.framework/src/common/assets/index_cmxt50/js/XT5_login.js'); });



/*****************
 ** WEBPACK FOOTER
 ** ./build/XT5-webpack/entry-loader.js!./web.modules/coremail.framework/src/common/assets/index_cmxt50/js/XT5_login.js
 ** module id = 0
 ** module chunks = 14
 **/